import { Component, Input, ViewEncapsulation } from '@angular/core';
import { StudentDashboardReturnService } from '@core/services/student/student-dashboard-return.service';
import { UserService } from '@core/user.service';

import { KeyValuePair } from '@models/key-value-pair';
import { Topic, TopicGroup } from '@models/topic';
import { NgbProgressbar, NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { TopicType } from '@shared/enums/topic-type';

@Component({
  selector: 'zbp-pin-progress-bar',
  templateUrl: './pin-progress-bar.component.html',
  styleUrls: ['./pin-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PinProgressBarComponent extends NgbProgressbar {
  @Input() topic: TopicGroup = null;
  @Input() classroomId: string = '';
  @Input() componentId: string = '';
  @Input() hasPin = false;

  constructor(
    private studentDashboardReturnService: StudentDashboardReturnService,
    private userService: UserService,
    private config: NgbProgressbarConfig) {
    super();
  }

  get topicItem(): Topic {
    return this.topic.items.find(t => t.topicType === TopicType.FreeWrite);
  }

  get canPin(): boolean {
    return !this.isLocked && !!this.topicItem;
  }

  get isLocked(): boolean {
    return this.topic.isLocked || !this.topic.items.find(t => t.topicType === TopicType.FreeWrite && !t.isLocked);
  }

  get label(): string {
    return this.canPin ? `My Portfolio for ${this.topicItem.unitName}` : 'Pin not available for this unit';
  }

  get isPinned(): boolean {
    return this.topic.items.findIndex(t => t.topicType === TopicType.FreeWrite && t.isPinned) !== -1;
  }

  open(): boolean {
    // Don't use getProductLauchPath so that we launch into digital-resources and not handwriting-trace.
    const basePath = `${window.location.origin}/sites/digital-resources/`;
    const params: KeyValuePair[] = [
      { key: 'componentId', value: this.componentId },
      { key: 'activity', value: this.topicItem.topicKey },
      { key: 'classroomId', value: this.classroomId },
    ];
    const url = params.reduce((result, param, index) => {
      const { key, value } = param;
      const encoded = encodeURIComponent(value);
      if (index === 0) {
        return `${result}?${key}=${encoded}`;
      }
      return `${result}&${key}=${encoded}`;
    }, basePath);

    if (this.userService.user.isStudent) {
      this.studentDashboardReturnService.returnToStudentDashboard();
    }
    window.open(url, '_blank');
    return false;
  }
}
